

define(['squid/index'], function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xomultistepsignupmodel', ['squid']).factory('$MultistepSignupModel', ['$Model', function ($Model) {
    return $Model.extend('MultistepSignupModel', {});
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/multistep-signup/index.js
// module id = ../node_modules/xo-guest-components/src/multistep-signup/index.js
// module chunks = 0